// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","LayoutPageWrapperDesktopScreenBreakpointMin":"(min-width: 640px)","subHead":"G8b14b6 G519ebe","copyOutOfCard":"G523251"};